'use client';

import { useSetAtom } from 'jotai';
import Script from 'next/script';

import { getCaptchaIdApi } from '@flipster/apis/v1/captcha';

import { Captcha, captchaAtom } from '@web/hooks/useCaptcha';

const GeetestEnum = {
  Auth: 'geetestCaptchaWebUserAuthPublicId',
  Create: 'geetestCaptchaWebUserCreatePublicId',
  PwReset: 'geetestCaptchaWebPwResetPublicId',
} as const;

export type GeetestCaptchaType = 'Auth' | 'Create' | 'PwReset';

interface Props {
  type?: GeetestCaptchaType;
}

const GeetestCaptcha = ({ type }: Props) => {
  const setCaptcha = useSetAtom(captchaAtom);

  if (!type) return null;
  return (
    <Script
      id='geetest-script'
      src='https://static.geetest.com/v4/gt4.js'
      strategy='lazyOnload'
      onReady={() => {
        if (!window.initGeetest4) return;
        getCaptchaIdApi().then((res) => {
          window.initGeetest4(
            {
              captchaId: res.data[GeetestEnum[type]],
              product: 'bind',
            },
            (c: Captcha) => setCaptcha(c),
          );
        });
      }}
    />
  );
};

export default GeetestCaptcha;
